import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../../api/request';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import {
  StudyPlanOffersLoaderQuery,
  StudyPlanOffersResponseType,
} from '../../types';
import { getStudyPlanOffers } from '../../api';
import DisplayError from '../../../../../components/info/DisplayError';

export interface StudyPlanOffersLoaderProps {
  children: ReactElement;
  initialPeriodId?: number;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  StudyPlanOffersLoaderQuery,
  StudyPlanOffersResponseType,
  AxiosResultDefaultError
>();

export const useStudyPlanOffers = useFetch;

export const StudyPlanOffersLoaderConsumer = FetchConsumer;

export function StudyPlanOffersLoader({
  children,
}: StudyPlanOffersLoaderProps) {
  const request = useCallback((query: StudyPlanOffersLoaderQuery) => {
    return getStudyPlanOffers(query);
  }, []);

  return (
    <FetchProvider
      request={request}
      defaultQuery={{ academicOfferId: undefined }}
      fetchImmediately
    >
      <FetchConsumer>
        {({ loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }
          return children;
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
